import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import ModuleList from '../../../layout/ModuleList';
import {
  clearDriverCommissions,
  getDriverCommissions,
} from '../../../../actions';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { DRIVER_COMMISSION_PATH } from '../../../../config/paths';
import { DRIVER_COMMISION_COLUMNS } from '../../../../config/columns';

const DriverCommissions = ({
  breadcrumbs,
  dispatchGetDriverCommissions,
  dispatchClearDriverCommissions,
  driverCommissions,
  loading,
}) => {
  useLayoutEffect(() => () => dispatchClearDriverCommissions(), []);

  const data = driverCommissions.get('content') || [];
  const pages = driverCommissions.get('totalPages') || null;
  const defaultPageSize = driverCommissions.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Comisiones de Conductores"
      breadcrumbs={breadcrumbs}
      buttonPath={`${DRIVER_COMMISSION_PATH}/new`}
      tableStructure={{
        columns: DRIVER_COMMISION_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetDriverCommissions,
        modelPath: DRIVER_COMMISSION_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

DriverCommissions.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetDriverCommissions: PropTypes.func.isRequired,
  dispatchClearDriverCommissions: PropTypes.func.isRequired,
  driverCommissions: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
};

DriverCommissions.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ HumanResourcesUnit }) => ({
  breadcrumbs: [
    ...HumanResourcesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Comisiones de Conductores',
      href: '',
    },
  ],
  driverCommissions: HumanResourcesUnit.DriverCommission.getIn([
    'all',
    'content',
  ]),
  loading: HumanResourcesUnit.DriverCommission.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetDriverCommissions: getDriverCommissions,
  dispatchClearDriverCommissions: clearDriverCommissions,
};

export default connect(mapStateToProps, mapDispatchToProps)(DriverCommissions);
